import React, { Component } from "react";
import classnames from "classnames";

import { IconName } from "@formant/ui/component/common/Icon";

import { ButtonProps } from "./Button";
import { CircleButton } from "./CircleButton";
import * as styles from "./HeaderButton.scss";

export interface IHeaderButtonProps extends ButtonProps {
    icon: IconName;
    className?: string;
    counter?: number;
    counterColor?: string;
}

export class HeaderButton extends Component<IHeaderButtonProps> {
    public render() {
        const { icon, className, children, counter, counterColor, ...props } =
            this.props;
        return (
            <CircleButton
                className={classnames(
                    styles["header-button"],
                    styles.button,
                    className,
                )}
                icon={icon}
                {...props}
            >
                {children}
                {!!counter && counter > 0 && (
                    <span
                        style={{ backgroundColor: counterColor || "#1995FC" }}
                        className={styles["notification-warning"]}
                    >
                        {counter > 99 ? "99+" : counter}
                    </span>
                )}
            </CircleButton>
        );
    }
}
